export const diasDaSemana = [
  //Array de Opções usadas no SELECT de dias da semana
  { id: 1, label: "Segunda-Feira", value: "SEGUNDA" },
  { id: 2, label: "Terça-Feira", value: "TERCA" },
  { id: 3, label: "Quarta-Feira", value: "QUARTA" },
  { id: 4, label: "Quinta-Feira", value: "QUINTA" },
  { id: 5, label: "Sexta-Feira", value: "SEXTA" },
  { id: 6, label: "Sábado", value: "SABADO" },
  { id: 7, label: "Domingo", value: "DOMINGO" },
];
